module.exports = __webpack_public_path__ + "static/media/MetalInVeins.90da6a67.jpg";